import { render } from "./AddNew.vue?vue&type=template&id=38cd7dc6"
import script from "./AddNew.vue?vue&type=script&lang=js"
export * from "./AddNew.vue?vue&type=script&lang=js"

import "./AddNew.vue?vue&type=style&index=0&id=38cd7dc6&lang=css"
script.render = render

export default script